import { useNotificationStore } from "@/common/store/notificationStore";
import {
  NOTIFICATION_DEFAULT_DURATION,
  NOTIFICATION_EXIT_ANIMATION_DURATION,
} from "@/components/notifications/Notifications/constants";
import type { NotificationData } from "@/common/types/notification";

type ShowNotificationParams = NotificationData & {
  duration?: number;
};

const closeTimers = new Map<string, number>();

const clearCloseTimer = (id: string) => {
  const t = closeTimers.get(id);
  if (t !== undefined) {
    window.clearTimeout(t);
    closeTimers.delete(id);
  }
};

export const showNotification = (params: ShowNotificationParams) => {
  const store = useNotificationStore.getState();
  const { duration = NOTIFICATION_DEFAULT_DURATION, ...data } = params;

  const id = store.add(data);

  clearCloseTimer(id);

  if (duration > 0) {
    const timer = window.setTimeout(() => {
      useNotificationStore.getState().close(id, NOTIFICATION_EXIT_ANIMATION_DURATION);
      closeTimers.delete(id);
    }, duration);

    closeTimers.set(id, timer);
  }

  return id;
};
